import { useState } from "react";
import Cropper from "react-easy-crop";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";
import { Loader2 } from "lucide-react";

const cropToBlob = (src, area) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement("canvas");
    canvas.width = 500;
    canvas.height = 500;
    canvas.getContext("2d").drawImage(img, area.x, area.y, area.width, area.height, 0, 0, 500, 500);
    canvas.toBlob((b) => (b ? resolve(b) : reject(new Error("Crop failed"))), "image/jpeg", 0.9);
  };
  img.onerror = reject;
  img.src = src;
});

export const PhotoCropDialog = ({ src, onCancel, onConfirm }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [area, setArea] = useState(null);
  const [busy, setBusy] = useState(false);

  const save = async () => {
    setBusy(true);
    try { await onConfirm(await cropToBlob(src, area)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!src} onOpenChange={(o) => { if (!o && !busy) onCancel(); }}>
      <DialogContent className="max-w-md" data-testid="photo-crop-dialog">
        <DialogHeader><DialogTitle>Crop &amp; centre photo</DialogTitle></DialogHeader>
        <div className="relative w-full h-72 bg-slate-900 rounded-lg overflow-hidden" data-testid="photo-crop-area">
          {src && <Cropper image={src} crop={crop} zoom={zoom} aspect={1} cropShape="round" showGrid={false} onCropChange={setCrop} onZoomChange={setZoom} onCropComplete={(_, px) => setArea(px)} />}
        </div>
        <div className="flex items-center gap-3 pt-2">
          <span className="text-xs text-slate-500">Zoom</span>
          <Slider value={[zoom]} min={1} max={3} step={0.05} onValueChange={([v]) => setZoom(v)} data-testid="photo-crop-zoom" />
        </div>
        <p className="text-xs text-slate-500">Drag the photo to centre the face inside the circle.</p>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={busy} data-testid="photo-crop-cancel">Cancel</Button>
          <Button onClick={save} disabled={busy || !area} data-testid="photo-crop-save">{busy && <Loader2 className="w-4 h-4 animate-spin mr-1" />}Save photo</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
